export const defaultStatus = [
  'Confirmed',
  'Checked-in',
  'Check-in (In Progress)',
  'Completed',
  'Holding',
  'Unconfirmed'
];

export const withDefaultStatus = (status = []) => [
  ...new Set([...defaultStatus, ...(Array.isArray(status) ? status : [])]),
];
